import { TitleProps } from 'src/features/home/components/title/title.types';
import { StyledTitle, StyledDivider, StyledTitleContainer } from 'src/features/home/components/title/title.styles';
export const Title = ({
  title,
  isLeft = false
}: TitleProps) => <StyledTitleContainer isLeft={isLeft} data-sentry-element="StyledTitleContainer" data-sentry-component="Title" data-sentry-source-file="title.tsx">
    <StyledTitle data-sentry-element="StyledTitle" data-sentry-source-file="title.tsx">{title}</StyledTitle>
    <StyledDivider data-sentry-element="StyledDivider" data-sentry-source-file="title.tsx" />
  </StyledTitleContainer>;